import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

const listeners = new Set<(isPrint: boolean) => void>()

let usedMediaQueryList: MediaQueryList | null = null
const globalMediaQueryHandler = (event: MediaQueryListEvent) => {
  for (const listener of listeners) {
    listener(event.matches)
  }
}

function registerPrintListener(listener: (isPrint: boolean) => void) {
  listeners.add(listener)
  const mediaQueryList = window.matchMedia('print')
  if (listeners.size === 1) {
    mediaQueryList.addEventListener('change', globalMediaQueryHandler)
    usedMediaQueryList = mediaQueryList
  }
  return mediaQueryList.matches
}

function unregisterPrintListener(listener: (isPrint: boolean) => void) {
  listeners.delete(listener)
  if (listeners.size === 0 && usedMediaQueryList) {
    usedMediaQueryList.removeEventListener('change', globalMediaQueryHandler)
    usedMediaQueryList = null
  }
}

export function useIsPrint() {
  const [isPrint, setIsPrint] = useState<boolean>(window.matchMedia('print').matches)

  useEffect(() => {
    let lastPrint: boolean | undefined
    const listener = (updated: boolean) => {
      // log.log('print changes', updated)
      setIsPrint(updated)

      if (updated && lastPrint !== updated) {
        // ensure all pending updates are flushed before printing, otherwise the print preview will be outdated
        ReactDOM.flushSync(() => {
          // log.log('flushed')
        })
      }

      lastPrint = updated
    }

    const newIsPrint = registerPrintListener(listener)
    setIsPrint(newIsPrint)

    return () => {
      unregisterPrintListener(listener)
    }
  }, [])

  return isPrint
}
